module.exports = __webpack_public_path__ + "media/newstyle/images/cta-mobile-en-58f7dcd087e5483d40b173dd41f7f604.png";